import { readonly, ref } from 'vue';

// Module-scoped so every bar and every Scheduled-row card shares one hover state — the same
// cross-component sharing idea as useRecentAssignmentHighlight, without touching the Pinia
// store (this is ephemeral UI state).
//
// Holds a block key, not a distribution-group id: keyed by the group alone, a manual block
// and a PO that lives on a single capacity type could never light up their siblings, while a
// distributed PO could. See segmentBlockKey / groupBlockKey for the shared identity.
const hoveredBlockKey = ref<string | null>(null);

export function useAssignmentHover() {
  function setHoveredBlock(key: string | null | undefined): void {
    hoveredBlockKey.value = key ?? null;
  }

  function clearHoveredBlock(): void {
    hoveredBlockKey.value = null;
  }

  return { hoveredBlockKey: readonly(hoveredBlockKey), setHoveredBlock, clearHoveredBlock };
}
